export enum GameStatus {
  OK,
  LOADING,
  ERROR,
}
